<template>
  <div class="card chart-card">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <div v-if="dataIsNotEmpty" class="card-box">
        <chartjs-doughnut :chart-data="chartData" :options="chartOptions" :text="text" :styles="pieChartStyle" class="pieChartCardBox"></chartjs-doughnut>
      </div>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
import Card from "../Card.vue";
import ChartjsDoughnut from "../../Chartjs/ChartjsDoughnut.vue";
import util from "util";
import _ from "lodash";

export default {
  name: "chartjs-doughnut-card",
  components: {
    Card,
    ChartjsDoughnut
  },
  computed: {
    dataIsNotEmpty() {
      return !(_.isNil(this.chartData) || _.isEmpty(this.chartData));
    },
    pieChartStyle() {
      return {
        //height: "300px",
        position: "relative"
      };
    }
  },
  props: ["chartData", "chartOptions","text"]
};
</script>
<style>
</style>
